/**
 * Run the coverage scan and question selection for the KB assistant panel.
 * Pure — no network, no writes.
 */

import { scanKbCoverage } from './coverageScan';
import { selectQuestions } from './selectQuestions';

const ABSOLUTE_URL = /https?:\/\/[^\s)\]>'"]+/gi;
const HIGH_VALUE_PATH = /(?:^|[\s"'=(])(\/(?:pricing|plans|rates)(?:\/[^\s)\]>'"]*)?)/gi;

function uniqueUrls(urls) {
  const seen = new Set();
  const out = [];
  for (const raw of urls) {
    const trimmed = (raw || '').replace(/[.,;:]+$/, '').trim();
    if (!trimmed || seen.has(trimmed)) continue;
    seen.add(trimmed);
    out.push(trimmed);
  }
  return out;
}

/** Absolute URLs plus bare /pricing, /plans, /rates paths found in KB text. */
export function extractKbLinks(text) {
  if (!text) return [];
  const found = [];
  const abs = text.match(ABSOLUTE_URL) || [];
  for (const url of abs) found.push(url);
  HIGH_VALUE_PATH.lastIndex = 0;
  let match;
  while ((match = HIGH_VALUE_PATH.exec(text)) !== null) {
    found.push(match[1]);
  }
  return uniqueUrls(found);
}

export function runKbAssistant({
  kbContent = '',
  scrapedPageUrls = [],
  discoveredLinks,
  chosenIndustry,
  regulatedConfirm,
}) {
  const scraped = Array.isArray(scrapedPageUrls) ? scrapedPageUrls.filter(Boolean) : [];
  const discovered = uniqueUrls([
    ...(discoveredLinks || []),
    ...extractKbLinks(kbContent),
    ...scraped,
  ]);
  const coverage = scanKbCoverage({
    kbContent,
    scrapedPageUrls: scraped,
    discoveredLinks: discovered,
  });
  const selection = selectQuestions({
    coverage,
    kbContent,
    chosenIndustry,
    regulatedConfirm,
  });
  return { coverage, selection };
}
